import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '@/components/site/PageBanner';
import SEO from '@/components/site/SEO';
import Reveal from '@/components/site/Reveal';
import axios from 'axios';
import { Briefcase, MapPin, Clock, ClipboardList } from 'lucide-react';

const API = process.env.REACT_APP_API_URL || '';

const jobs = [
  { title: 'Relationship Manager — Home Loans',   location: 'Mumbai', type: 'Full-time' },
  { title: 'Sales Executive — Personal Loans',    location: 'Mumbai', type: 'Full-time' },
  { title: 'Tele-Sales Executive',                location: 'Mumbai', type: 'Full-time' },
  { title: 'Credit Analyst',                      location: 'Mumbai', type: 'Full-time' },
];

const inputCls =
  'h-11 px-3.5 border border-slate-200 rounded-lg bg-white outline-none transition focus:border-[#1e73be] focus:ring-2 focus:ring-[#1e73be]/20';

const Careers = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', role: '' });
  const [done, setDone] = useState(false);

  const apply = (role) => {
    setForm((f) => ({ ...f, role }));
    document.getElementById('apply-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/api/forms/submit`, { form_type: 'career', data: form });
    } catch (_) { /* silent fallback */ }
    setDone(true);
  };

  return (
    <main>
      <SEO
        title="Careers at Finirio | Join Mumbai's Fastest Growing Loan Platform"
        description="Explore career opportunities at Finirio. We are hiring relationship managers, credit analysts and sales executives in Mumbai. Apply today."
        path="/careers"
        keywords="finirio careers, jobs at finirio, loan advisor jobs, bfsi careers mumbai"
      />
      <PageBanner title="Careers" crumbs={['Careers']} />
      <section className="py-16 bg-white">
        <div className="max-w-[1100px] mx-auto px-4 lg:px-6">

          {/* ── Assessment CTA — top of page ── */}
          <Reveal>
            <div className="mb-12 rounded-2xl overflow-hidden shadow-[0_24px_50px_-24px_rgba(11,37,69,.45)] relative">
              <div className="hairline-gold absolute top-0 left-0 right-0 z-10" />
              <div className="p-8 flex flex-col sm:flex-row items-center gap-6 navy-panel">
                <div className="w-16 h-16 rounded-2xl bg-white/10 border border-[#e8c887]/25 flex items-center justify-center shrink-0">
                  <ClipboardList className="w-8 h-8 text-[#e8c887]" />
                </div>
                <div className="text-center sm:text-left flex-1">
                  <p className="text-[#e8c887] text-[12px] font-bold uppercase tracking-[.18em] mb-1">Recruitment Assessment</p>
                  <h3 className="font-heading text-xl font-bold text-white mb-1">Take Our Aptitude Test</h3>
                  <p className="text-white/70 text-sm">
                    Shortlisted for a role? Complete our 20-minute aptitude test — English, Maths, Logical Reasoning &amp; Reading Comprehension.
                  </p>
                </div>
                <Link to="/assessment" className="btn-lux btn-gold shrink-0 whitespace-nowrap">
                  Start Assessment →
                </Link>
              </div>
            </div>
          </Reveal>

          <p className="text-slate-600 leading-relaxed mb-10 max-w-[760px]">
            Join Finirio and help empower millions of Indians on their journey to financial independence.
            We are always looking for passionate people who care about customers as much as we do.
          </p>

          <h2 className="font-heading text-[26px] font-bold text-[#0b2545] mb-2">Current Openings</h2>
          <span className="block h-[2px] w-14 mb-7 rounded-full" style={{ background: 'linear-gradient(90deg,#c9a24b,#e8c887)' }} />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {jobs.map((j, i) => (
              <Reveal key={i} delay={(i % 2) * 100}>
                <div className="card-lux p-6 h-full">
                  <h3 className="font-heading font-bold text-[#0b2545] text-lg mb-2">{j.title}</h3>
                  <div className="flex items-center gap-4 text-sm text-slate-600 mb-4 flex-wrap">
                    <span className="flex items-center gap-1"><MapPin className="w-4 h-4 text-[#c9a24b]" />{j.location}</span>
                    <span className="flex items-center gap-1"><Clock className="w-4 h-4 text-[#c9a24b]" />{j.type}</span>
                    <span className="flex items-center gap-1"><Briefcase className="w-4 h-4 text-[#c9a24b]" />BFSI</span>
                  </div>
                  <button onClick={() => apply(j.title)} className="btn-lux !px-5 !py-2 !text-sm">Apply</button>
                </div>
              </Reveal>
            ))}
          </div>

          <div id="apply-form" className="mt-14 card-lux p-8 max-w-[720px] mx-auto">
            <h3 className="font-heading text-[22px] font-bold text-[#0b2545] mb-1">Apply Now</h3>
            <span className="block h-[2px] w-12 mb-5 rounded-full" style={{ background: 'linear-gradient(90deg,#c9a24b,#e8c887)' }} />
            {done ? (
              <p className="text-slate-700">Thanks for applying! Our HR team will get back to you.</p>
            ) : (
              <form className="grid grid-cols-1 md:grid-cols-2 gap-4" onSubmit={submit}>
                <input required placeholder="Full Name" value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className={inputCls} />
                <input required placeholder="Email" type="email" value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className={inputCls} />
                <input required placeholder="Phone" value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  className={inputCls} />
                <input placeholder="Applying for" value={form.role}
                  onChange={(e) => setForm({ ...form, role: e.target.value })}
                  className={inputCls} />
                <button type="submit" className="btn-lux md:col-span-2 justify-center !py-3">Submit Application</button>
              </form>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Careers;
